import { Route } from 'vue-router'
import difference from 'lodash/difference'
import uniq from 'lodash/uniq'
import { Languages } from './index'
import { Modules } from '../util/modules'
import * as Sentry from '@sentry/vue'

export const translationsDiffChecker = (to: Route, from: Route): string[] => {
  const loadedTranslations = (to?.meta?.translations ?? []).sort()
  const toLoadTranslations = (from?.meta?.translations ?? []).sort()

  return difference(loadedTranslations, toLoadTranslations)
}

// Setup to load multiple modules

export const initCache = () => {
  let cachedLocales: Record<string, string[]> = {}

  const setCacheAndGetToLoad = (lang: Languages, modules: Modules[]) => {
    const transformedLang = transformLanguage(lang)
    if (!cachedLocales[transformedLang]) {
      cachedLocales[transformedLang] = []
    }

    const _modules = modules.map(m => m?.trim())

    const toLoad = uniq(difference(_modules, cachedLocales[transformedLang]))

    cachedLocales[transformedLang] = uniq([
      ...cachedLocales[transformedLang],
      ...toLoad,
    ])
      .map(e => e?.trim())
      .sort()

    return toLoad
  }

  const dropCache = () => {
    cachedLocales = {}
  }

  const getCache = () => {
    return cachedLocales
  }

  // For debugging
  if (window) {
    window['__dropCache'] = dropCache
    window['__showCache'] = getCache
  }

  return {
    cachedLocales,
    setCacheAndGetToLoad,
    dropCache,
    getCache,
  }
}

export const transformLanguage = (language: string) => {
  let transformedLanguage = language
  if (transformedLanguage.includes('_')) {
    transformedLanguage = transformedLanguage.replace('_', '-')
  }
  transformedLanguage = transformedLanguage.replace(/['"]/g, '')
  return transformedLanguage
}
